import {postIssuePersonal} from '../api/postIssuePersonal';

const setPostIssuePersonal = (params, setOpenModal, setStep, setOpenModalErrors, setSelectId) => {
    return async (dispatch, getState) => {
        try {   
            const temp = {
                gamer: params.select_gamer, 
                bonus_name: params.bonuses, 
                cause: params.cause
            }

            const {data} = await postIssuePersonal(temp);

            if (data.status === 'success') {
                setOpenModal(true);
                setStep(1);
                setSelectId([])
            }
        
        } catch(error) {
            setOpenModalErrors(true)
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostIssuePersonal
}